export default __webpack_public_path__ + "static/media/TopicTip_Upgrade images.45d1af72.svg";